import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteConfirmationDialogComponent } from './delete-confirmation';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  declarations: [DeleteConfirmationDialogComponent],
  imports: [
    CommonModule,    
    MatButtonModule,
    MatDialogModule
  ],
  exports: [DeleteConfirmationDialogComponent]
})
export class DeleteConfirmationModule { }
